const React = require('react');
const { View, StyleSheet } = require('react-native');
const lottie = require('lottie-web').default || require('lottie-web');

const LottieView = React.forwardRef((props, ref) => {
  const containerRef = React.useRef(null);
  const animRef = React.useRef(null);
  const { source, autoPlay = true, loop = true, style, onAnimationFinish, speed = 1 } = props;

  React.useImperativeHandle(ref, () => ({
    play: (startFrame, endFrame) => {
      if (animRef.current) {
        if (typeof startFrame === 'number' && typeof endFrame === 'number' && endFrame !== -1) {
          animRef.current.playSegments([startFrame, endFrame], true);
        } else {
          animRef.current.play();
        }
      }
    },
    reset: () => {
      if (animRef.current) {
        animRef.current.goToAndStop(0, true);
      }
    },
    pause: () => {
      if (animRef.current) {
        animRef.current.pause();
      }
    },
    resume: () => {
      if (animRef.current) {
        animRef.current.play();
      }
    },
  }));

  React.useEffect(() => {
    const el = containerRef.current;
    if (!el || !source) return;

    let animationData = source;
    if (typeof source === 'string') {
      try {
        animationData = JSON.parse(source);
      } catch (e) {
        // Keep as string for URI or path
      }
    } else if (source && source.default) {
      animationData = source.default;
    }

    try {
      if (animRef.current) {
        animRef.current.destroy();
      }

      el.innerHTML = '';

      animRef.current = lottie.loadAnimation({
        container: el,
        renderer: 'svg',
        loop: !!loop,
        autoplay: !!autoPlay,
        animationData: typeof animationData === 'object' ? animationData : undefined,
        path: typeof animationData === 'string' ? animationData : undefined,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
          clearCanvas: true,
          progressiveLoad: true,
          hideOnTransparent: true,
        },
      });

      if (speed && animRef.current) {
        animRef.current.setSpeed(speed);
      }

      if (onAnimationFinish && animRef.current) {
        animRef.current.addEventListener('complete', () => {
          onAnimationFinish(false);
        });
      }
    } catch (err) {
      console.warn('Lottie web load error:', err);
      if (onAnimationFinish) {
        onAnimationFinish(false);
      }
    }

    return () => {
      if (animRef.current) {
        animRef.current.destroy();
        animRef.current = null;
      }
    };
  }, [source, loop, autoPlay, speed]);

  const flatStyle = StyleSheet.flatten(style) || {};

  return React.createElement(View, {
    ref: containerRef,
    style: [
      {
        overflow: 'hidden',
        alignItems: 'center',
        justifyContent: 'center',
        width: 300,
        height: 300,
      },
      flatStyle,
    ],
  });
});

module.exports = LottieView;
module.exports.default = LottieView;
